__turbopack_context__.v({
  "skipLink": "SkipLink-module-scss-module__rJg-lG__skipLink",
});
